module.exports = __webpack_public_path__ + "static/media/IMG_20180804_095409.9af87295.jpg";